import { useEffect, useState } from "react";
import {
  Box,
  Container,
  Heading,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Button,
  VStack,
  InputGroup,
  InputLeftAddon,
  useToast,
} from "@chakra-ui/react";
import Layout from "../../layout/Layout";
import { useContactEmailMutation } from "../../services/places";

const Contact = () => {
  const toast = useToast();
  const [doContactEmail, { isLoading, isError, data: responseData }] =
    useContactEmailMutation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobileNumber: "",
    message: "",
    subject: "Contact Us - api-playground.potterstech.com",
  });

  const handleChange = (event: { target: { name: any; value: any } }) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (event: { preventDefault: () => void }) => {
    event.preventDefault();
    doContactEmail(formData);
  };

  // Display toast based on result of doContactEmail
  useEffect(() => {
    // Success toast
    !isError &&
      responseData &&
      toast({
        title: "Success!",
        description: "Email was successfully sent",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    // Error toast
    isError &&
      toast({
        title: "Error!",
        description: "Please contact us at tech@potterstech.com",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
  }, [isError, responseData]);

  return (
    <Layout
      children={
        <Container>
          <Box
            // boxShadow={"inset 2px 2px 6px #bebebe, inset -2px -2px 6px #ffffff"}
            // bg="gray.100"
            p={8}
            // w={"50%"}
            borderRadius="md"
          >
            <Heading as="h1" size="xl" mb={6}>
              Contact Us
            </Heading>
            {/* <Text mt="20px" mb="20px" color={"red"} align={"center"}>
          This feature is temporarily disabled. Please write to us at
          tech@potterstech.com
        </Text> */}

            <form onSubmit={handleSubmit}>
              <FormControl id="name" isRequired mb={4}>
                <FormLabel>Name</FormLabel>
                <Input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter your name"
                />
              </FormControl>
              <FormControl id="mobileNumber" isRequired mb={4}>
                <FormLabel>Mobile Number (with Country Code)</FormLabel>
                <InputGroup>
                  <InputLeftAddon children="+ " />
                  <Input
                    type="number"
                    name="mobileNumber"
                    value={formData.mobileNumber}
                    onChange={handleChange}
                    placeholder="Enter your mobile number"
                  />
                </InputGroup>
              </FormControl>
              <FormControl id="email" isRequired mb={4}>
                <FormLabel>Email</FormLabel>
                <Input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                />
              </FormControl>
              <FormControl id="message" isRequired mb={4}>
                <FormLabel>Message</FormLabel>
                <Textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Enter your message"
                />
              </FormControl>
              <Box display="flex" justifyContent="center">
                <Button
                  // isDisabled
                  isLoading={isLoading}
                  bg="black"
                  color="white"
                  _hover={{
                    bg: "white",
                    color: "black",
                    borderColor: "black",
                  }}
                  type="submit"
                  variant={"outline"}
                >
                  Submit
                </Button>
              </Box>
            </form>
          </Box>
        </Container>
      }
    />
  );
};

export default Contact;
